import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "./About.css";
import caMadhuri from "../images/madhuri_image.jpg";

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div style={styles.container}>
      {/* Hero Section */}
      <motion.div 
        style={styles.heroSection}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h1 style={styles.title}>Meet CA Madhuri</h1>
        <p style={styles.subtitle}>Your Trusted Financial Partner for Growth & Success</p>
      </motion.div>

      {/* About CA Madhuri */}
      <div style={styles.aboutSection} data-aos="fade-up">
        <div style={styles.profileContainer}>
          <motion.img 
            src={caMadhuri} 
            alt="CA Madhuri" 
            style={styles.profileImage}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          />
          <div style={styles.profileContent}>
            <h2 style={styles.heading}>CA Madhuri Chaudhari</h2>
            <p style={styles.designation}>Chartered Accountant & Financial Advisor</p>
            <p style={styles.description}>
              With over 15+ years of expertise in taxation, financial planning, and business advisory, CA Madhuri is dedicated to transforming financial challenges into growth opportunities. Her comprehensive understanding of GST, income tax, and corporate compliance makes her the go-to advisor for businesses of all sizes.
            </p>
            <p style={styles.description}>
              CA Madhuri believes in building long-term relationships with clients through transparency, reliability, and exceptional service delivery. She has successfully guided 500+ clients through complex financial landscapes and continues to be their trusted partner in achieving financial excellence.
            </p>
          </div>
        </div>
      </div>

      {/* Expertise & Specializations */}
      <div style={styles.section} data-aos="zoom-in">
        <h2 style={styles.heading}>🎯 Areas of Expertise</h2>
        <div style={styles.expertiseGrid}>
          {[
            { title: "Tax Planning", desc: "Strategic tax optimization for maximum savings" },
            { title: "GST Compliance", desc: "Seamless GST registration and monthly filings" },
            { title: "Audit Services", desc: "Internal & statutory audits for compliance" },
            { title: "Business Setup", desc: "Company registration & legal structure planning" },
            { title: "Financial Advisory", desc: "Investment guidance and wealth management" },
            { title: "Corporate Compliance", desc: "ROC filings, annual compliances & more" },
          ].map((item, index) => (
            <motion.div 
              key={index} 
              style={styles.expertiseCard}
              data-aos="fade-up"
              whileHover={{ y: -10 }}
            >
              <h4 style={styles.cardTitle}>{item.title}</h4>
              <p style={styles.cardDesc}>{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Why Choose CA Madhuri */}
      <div style={styles.section} data-aos="fade-up">
        <h2 style={styles.heading}>✨ Why Choose CA Madhuri?</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>🏆 15+ Years of Excellence in Financial Services</li>
          <li style={styles.listItem}>👥 500+ Happy Clients Across Industries</li>
          <li style={styles.listItem}>💼 Specialized in Startup & Small Business Advisory</li>
          <li style={styles.listItem}>🔐 100% Confidential & Professional Service</li>
          <li style={styles.listItem}>⚡ Quick & Efficient Problem Resolution</li>
          <li style={styles.listItem}>📊 Data-Driven Financial Strategies</li>
          <li style={styles.listItem}>🎯 Customized Solutions for Every Client</li>
          <li style={styles.listItem}>📱 24/7 Client Support & Assistance</li>
        </ul>
      </div>

      {/* Mission & Vision */}
      <div style={styles.missionVisionSection}>
        <motion.div 
          style={styles.missionBox}
          data-aos="fade-right"
          whileHover={{ scale: 1.02 }}
        >
          <h3 style={styles.mvTitle}>🎯 Our Mission</h3>
          <p style={styles.mvText}>
            To empower businesses and individuals with strategic financial guidance, ensuring sustainable growth, tax efficiency, and complete peace of mind through professional excellence.
          </p>
        </motion.div>

        <motion.div 
          style={styles.visionBox}
          data-aos="fade-left"
          whileHover={{ scale: 1.02 }}
        >
          <h3 style={styles.mvTitle}>🌟 Our Vision</h3>
          <p style={styles.mvText}>
            To be the most trusted and preferred CA firm in the region, known for integrity, innovation, and delivering exceptional value to every client we serve.
          </p>
        </motion.div>
      </div>

      {/* Office Location */}
      <div style={styles.officeSection} data-aos="zoom-in">
        <h2 style={styles.heading}>📍 Visit Our Office</h2>
        <p style={styles.officeText}>
          <strong>CA Madhuri - Chartered Accountant</strong>
        </p>
        <p style={styles.officeText}>
          55B Narsi vihar<br/>
          Near Mandi Chauraha, Mathura<br/>
          Uttar Pradesh 281004, India
        </p>
        <p style={styles.officeText}>
          <strong>📞 Phone:</strong> +91 79834 28842<br/>
          <strong>📧 Email:</strong> camadhurico@gmail.com<br/>
          <strong>⏰ Hours:</strong> Mon-Sat 9:00 AM - 6:00 PM
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "1200px",
    margin: "auto",
    padding: "40px 20px",
    backgroundColor: "#f5f7fa",
  },
  heroSection: {
    textAlign: "center",
    marginBottom: "60px",
    padding: "40px 20px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    borderRadius: "15px",
    color: "white",
  },
  title: {
    fontSize: "3.5rem",
    fontWeight: "900",
    marginBottom: "10px",
    letterSpacing: "2px",
  },
  subtitle: {
    fontSize: "1.3rem",
    fontWeight: "300",
    opacity: 0.95,
  },
  aboutSection: {
    marginBottom: "60px",
  },
  profileContainer: {
    display: "flex",
    gap: "40px",
    alignItems: "center",
    backgroundColor: "white",
    padding: "40px",
    borderRadius: "15px",
    boxShadow: "0px 15px 35px rgba(0, 0, 0, 0.1)",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  profileImage: {
    borderRadius: "15px",
    width: "250px",
    height: "300px",
    objectFit: "cover",
    boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)",
  },
  profileContent: {
    flex: 1,
    minWidth: "300px",
    textAlign: "left",
  },
  heading: {
    fontSize: "2rem",
    fontWeight: "bold",
    color: "#2d3748",
    marginBottom: "15px",
  },
  designation: {
    fontSize: "1.3rem",
    color: "#667eea",
    fontWeight: "600",
    marginBottom: "15px",
  },
  description: {
    fontSize: "1rem",
    color: "#555",
    lineHeight: "1.8",
    marginBottom: "15px",
  },
  section: {
    background: "white",
    padding: "40px",
    borderRadius: "15px",
    marginBottom: "40px",
    boxShadow: "0px 10px 25px rgba(0, 0, 0, 0.08)",
    textAlign: "center",
  },
  expertiseGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "25px",
    marginTop: "30px",
  },
  expertiseCard: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    padding: "25px",
    borderRadius: "12px",
    color: "white",
    textAlign: "center",
    boxShadow: "0px 8px 20px rgba(102, 126, 234, 0.3)",
  },
  cardTitle: {
    fontSize: "1.3rem",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  cardDesc: {
    fontSize: "0.95rem",
    lineHeight: "1.6",
  },
  list: {
    listStyle: "none",
    padding: "0",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "15px",
    marginTop: "30px",
  },
  listItem: {
    fontSize: "1.05rem",
    color: "#2d3748",
    padding: "15px",
    backgroundColor: "#f0f4ff",
    borderRadius: "8px",
    borderLeft: "4px solid #667eea",
  },
  missionVisionSection: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "30px",
    marginBottom: "40px",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr",
    },
  },
  missionBox: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    padding: "30px",
    borderRadius: "12px",
    color: "white",
    boxShadow: "0px 10px 25px rgba(102, 126, 234, 0.3)",
  },
  visionBox: {
    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    padding: "30px",
    borderRadius: "12px",
    color: "white",
    boxShadow: "0px 10px 25px rgba(245, 87, 108, 0.3)",
  },
  mvTitle: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    marginBottom: "15px",
  },
  mvText: {
    fontSize: "1rem",
    lineHeight: "1.8",
  },
  officeSection: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    padding: "40px",
    borderRadius: "15px",
    textAlign: "center",
    boxShadow: "0px 15px 35px rgba(0, 0, 0, 0.15)",
  },
  officeText: {
    fontSize: "1.05rem",
    marginBottom: "10px",
    lineHeight: "1.8",
  },
};

export default About;
